import { useState, useContext, createContext } from "react";

const loadingContext = createContext();

function useLoading() {
  const [loading, setLoading] = useState(false);

  return {
    loading,
    setLoading,
  };
}

export function LoaderProvider({ children }) {
  const loading = useLoading();

  return (
    <loadingContext.Provider value={loading}>
      {children}
    </loadingContext.Provider>
  );
}

export default function useLoaderContext() {
  return useContext(loadingContext);
}

export const Loader = () => {
  return (
    <div
      style={{
        // width: "100vw",
        // height: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only"> </span>
      </div>
    </div>
  );
};
